import React, { useEffect, useRef } from 'react';
import { FiX } from 'react-icons/fi';
import ReservationForm from './ReservationForm';
import { useReservation } from '../contexts/ReservationContext';
import './ReservationModal.css';

const ReservationModal = () => {
  const { isOpen, close, prefill } = useReservation();
  const dialogRef = useRef(null);

  useEffect(() => {
    if (isOpen && dialogRef.current) {
      dialogRef.current.focus();
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) close();
  };

  return (
    <div
      className="reservation-modal-backdrop"
      onClick={handleBackdropClick}
      role="presentation"
    >
      <div
        className="reservation-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="reservation-modal-title"
        ref={dialogRef}
        tabIndex={-1}
      >
        <button
          type="button"
          className="reservation-modal-close"
          onClick={close}
          aria-label="Fermer la réservation"
        >
          <FiX size={22} />
        </button>

        <div className="reservation-modal-body">
          <ReservationForm prefill={prefill} onSuccess={close} />
        </div>
      </div>
    </div>
  );
};

export default ReservationModal;
